export default function asArray(source) {
    return Array.isArray(source) ? source : [source];
}
